module.exports = __webpack_public_path__ + "img/cimentaologo.08e011a5.jpg";